// Internal modules
import { $logger } from '@/lib/logger';
import { redirectToGenericError } from '@/lib/utils/redirects';
import {
  isIframe,
  isIncontext,
  isLegacyIncontext,
  isPopup,
} from '@/lib/utils/incontext';

const checkFrameBust = () => {
  if (isIframe() && !window?.paypal?.allowIframe()) {
    $logger.info('frame_bust_disallowed_iframe');
    try {
      window.top.location = window.location.href;
    } catch (err) {
      $logger.error('frame_bust_failed', err);
    }

    setTimeout(() => {
      $logger.error('frame_bust_did_not_redirect_after_2s');
      redirectToGenericError();
    }, 2000);
  }
};

const logIncontext = () => {
  if (isIncontext()) {
    $logger.info('incontext_integration', {
      isLegacyIntegration: isLegacyIncontext(),
      type: isPopup() ? 'popup' : 'iframe',
      xprops: Boolean(window.xprops),
    });
  }
};

export { checkFrameBust, logIncontext };
